module.exports = __webpack_public_path__ + "media/assets/images/blog/makeIThappen-3e534fc21c215648ab17948a5ba44c7d.jpg";